function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "transform-adaptation-change-reform-rebrand"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31,18c4.963,0,9-4.038,9-9s-4.037-9-9-9s-9,4.038-9,9S26.037,18,31,18z M31,2c3.859,0,7,3.14,7,7s-3.141,7-7,7 s-7-3.14-7-7S27.141,2,31,2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.863,51.505c0.18-0.307,0.183-0.686,0.008-0.995l-9-16c-0.354-0.63-1.389-0.63-1.742,0l-9,16 c-0.175,0.31-0.172,0.688,0.008,0.995S0.645,52,1,52h18C19.356,52,19.684,51.812,19.863,51.505z M2.71,50L10,37.04L17.29,50H2.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63,35c0-0.552-0.448-1-1-1H46c-0.552,0-1,0.448-1,1v16c0,0.552,0.448,1,1,1h16c0.552,0,1-0.448,1-1V35z M61,50H47V36h14 V50z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31,57c-4.643,0-9.146-1.328-13.025-3.839l-1.088,1.679C21.091,57.562,25.971,59,31,59c5.22,0,10.255-1.541,14.561-4.457 l-1.121-1.656C40.466,55.578,35.819,57,31,57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.982,32.039l1.998-0.078c-0.375-9.548-5.947-18.098-14.54-22.315l-0.881,1.796 C49.491,15.334,54.635,23.227,54.982,32.039z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.076,34.921C7.026,34.29,7,33.644,7,33c0-9.229,5.15-17.49,13.44-21.558L19.56,9.646C10.579,14.054,5,23.002,5,33 c0,0.697,0.027,1.396,0.082,2.08L7.076,34.921z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.293,7.293l1.414,1.414l3-3c0.391-0.391,0.391-1.023,0-1.414l-3-3l-1.414,1.414L17.586,4H11v2h6.586L16.293,7.293z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59,23c0.256,0,0.512-0.098,0.707-0.293l3-3l-1.414-1.414L60,19.586V13h-2v6.586l-1.293-1.293l-1.414,1.414l3,3 C58.488,22.902,58.744,23,59,23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.293,54.293l-3,3l1.414,1.414L9,57.414V64h2v-6.586l1.293,1.293l1.414-1.414l-3-3 C10.317,53.902,9.684,53.902,9.293,54.293z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40,32c0-3.203-1.724-6.19-4.499-7.795l-1.002,1.731C36.658,27.185,38,29.508,38,32c0,3.261-2.246,6.001-5.269,6.775 l1.164-2.327l-1.789-0.895l-2,4c-0.192,0.385-0.117,0.85,0.188,1.154l3,3l1.414-1.414l-1.562-1.562C37.074,39.765,40,36.222,40,32z "
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.502,39.797l1-1.731C25.342,36.817,24,34.493,24,32c0-3.261,2.246-6.001,5.269-6.775l-1.164,2.327l1.789,0.895l2-4 c0.192-0.385,0.117-0.85-0.188-1.154l-3-3l-1.414,1.414l1.562,1.562C24.927,24.235,22,27.778,22,32 C22,35.205,23.725,38.192,26.502,39.797z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
});

var SvgAdaptation = function SvgAdaptation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 64",
    style: {
      enableBackground: "new 0 0 63 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdaptation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adaptation.f4ae4202.svg";
export { ForwardRef as ReactComponent };